export const Filmphotos = [ 
    
{

id:'1',
Title: ' drinking wine',
img: require('../data/photos/Mike.jpg'),
Dates: '30-9-24',




},

{

    id:'2',
    Title: 'Me and my bestie',
    img: require('../data/photos/me.jpg'),
    Dates:"3-10-24"
    
    
    
    
    },

    {

        id:'3',
        Title:"ship",
        img: require('../data/photos/106.jpg'),
        Dates:"3-10-24"
        
        
        
        
        }, 


        {

            id:'4',
            Title:"Frens Playing call of duty",
            img: require('../data/photos/Friends.jpg'),
            Dates:"26-9-24"
            
            
            
            
            },




            {

                id:'5',
            Title:"Frens for ever",
            img: require('../data/photos/116.jpg'),
            Dates:"3-10-24"
                
                
                
                
                },





                {

                    id:'6',
                    Title:"Bridge",
                    img: require('../data/photos/110.jpg'),
                    Dates:"3-10-24"
                    
                    
                    
                    
                    },








                    {

                        id:'7',
                    Title:"Vinito",
                    img: require('../data/photos/vinito.jpg'),
                    Dates:"3-10-24"
                        
                        
                        
                        
                        },



                        {

                            id:'8',
                            Title:"Venezia",
                            img: require('../data/photos/venezia.jpg'),
                            Dates:"3-10-24"
                                
                            
                            
                            
                            
                            },


                            {

                                id:'9',
                                Title:"Politics",
                                img: require('../data/photos/politics.jpg'),
                                Dates:"3-10-24"
                                    
                                
                                
                                
                                
                                },


                                {

                                    id:'10',
                                    Title:"me again",
                                    img: require('../data/photos/115.jpg'),
                                    Dates:"4-10-24"
                                        
                                    
                                    
                                    
                                    
                                    },




                                    {

                                        id:'11',
                                        Title:"Gamer",
                                        img: require('../data/photos/jorgegamer.jpg'),
                                        Dates:"1-10-24"
                                            
                                        
                                        
                                        
                                        
                                        },



                                        {

                                            id:'12',
                                            Title:"Camila and me",
                                            img: require('./photos/116.jpg'),
                                            Dates:"4-10-24"
                                                
                                            
                                            
                                            
                                            
                                            },



                                            {

                                                id:'13',
                                                Title:"eating",
                                                img: require('../data/photos/eating.jpg'),
                                                Dates:"4-10-24"
                                                    
                                                
                                                
                                                
                                                
                                                },



                                                {

                                                    id:'14',
                                                    Title:"beer",
                                                    img: require('../data/photos/drinking.jpg'),
                                                    Dates:"4-10-24"
                                                        
                                                    
                                                    
                                                    
                                                    
                                                    },
                                                    {

                                                        id:'15',
                                                        Title:"Castle",
                                                        img: require('../data/photos/Castle.jpg'),
                                                        Dates:"30-9-24"
                                                            
                                                        
                                                        
                                                        
                                                        
                                                        },


                                                        {

                                                            id:'16',
                                                            Title:"aunt Camila",
                                                            img: require('../data/photos/Camila.jpg'),
                                                            Dates:"4-9-24"
                                                                
                                                            
                                                            
                                                            
                                                            
                                                            }, 


                                                            {

                                                                id:'17',
                                                                Title:"5 years of frienship",
                                                                img: require('../data/photos/CamilAgain.jpg'),
                                                                Dates:"4-9-24"
                                                                    
                                                                
                                                                
                                                                
                                                                
                                                                },


                                                                {

                                                                    id:'17',
                                                                    Title:"Anuel br",
                                                                    img: require('../data/photos/Anuel.jpg'),
                                                                    Dates:"6-9-24"
                                                                        
                                                                    
                                                                    
                                                                    
                                                                    
                                                                    },


                                                                    {

                                                                        id:'18',
                                                                        Title:"brunch",
                                                                        img: require('../data/photos/brunch.jpg'),
                                                                        Dates:"5-9-24"
                                                                            
                                                                        
                                                                        
                                                                        
                                                                        
                                                                        },

                                                                {
                                                                        id:'18',
                                                                        Title:"Antonito",
                                                                        img: require('../data/photos/Antonio.jpg'),
                                                                        Dates:"5-9-24"
                                                                            
                                                                        
                                                                        
                                                                        
                                                                        
                                                                        },


                                                                        // second batch

                                                                        {
                                                                            id:'19',
                                                                            Title:"Builders",
                                                                            img: require('../data/photos/1.jpeg'),
                                                                            Dates:"20-11-24"
                                                                                
                                                                            
                                                                            
                                                                            
                                                                            
                                                                            },


                                                                            {
                                                                                id:'20',
                                                                                Title:"playita",
                                                                                img: require('../data/photos/3.jpeg'),
                                                                                Dates:"20-11-24"
                                                                                    
                                                                                
                                                                                
                                                                                
                                                                                
                                                                                },


                                                                                {
                                                                                    id:'21',
                                                                                    Title:"Surf",
                                                                                    img: require('../data/photos/000002.jpeg'),
                                                                                    Dates:"20-11-24"
                                                                                        
                                                                                    
                                                                                    
                                                                                    
                                                                                    
                                                                                    },


                                                                                    {
                                                                                        id:'22',
                                                                                        Title:"Ocean",
                                                                                        img: require('../data/photos/4.jpeg'),
                                                                                        Dates:"20-11-24"
                                                                                            
                                                                                        
                                                                                        
                                                                                        
                                                                                        
                                                                                        },
                                                                                        {
                                                                                            id:'23',
                                                                                            Title:"Random",
                                                                                            img: require('../data/photos/5.jpeg'),
                                                                                            Dates:"20-11-24"
                                                                                                
                                                                                            
                                                                                            
                                                                                            
                                                                                            
                                                                                            },



                                                                                            {
                                                                                                id:'24',
                                                                                                Title:"After Surf",
                                                                                                img: require('../data/photos/6.jpeg'),
                                                                                                Dates:"1-11-24"
                                                                                                    
                                                                                                
                                                                                                
                                                                                                
                                                                                                
                                                                                                },

                                                                                                {
                                                                                                    id:'25',
                                                                                                    Title:"before Surf",
                                                                                                    img: require('../data/photos/000007.jpeg'),
                                                                                                    Dates:"1-11-24"
                                                                                                        
                                                                                                    
                                                                                                    
                                                                                                    
                                                                                                    
                                                                                                    },

                                                                                                    {
                                                                                                        id:'26',
                                                                                                        Title:"Home after Party",
                                                                                                        img: require('../data/photos/000021.jpeg'),
                                                                                                        Dates:"5-12-24"
                                                                                                            
                                                                                                        
                                                                                                        
                                                                                                        
                                                                                                        
                                                                                                        },



                                                                                                        {
                                                                                                            id:'27',
                                                                                                            Title:"Solecito",
                                                                                                            img: require('../data/photos/000008.jpeg'),
                                                                                                            Dates:"30-10-24"
                                                                                                                
                                                                                                            
                                                                                                            
                                                                                                            
                                                                                                            
                                                                                                            },



                                                                                                            {
                                                                                                                id:'28',
                                                                                                                Title:"Mi cueva",
                                                                                                                img: require('../data/photos/000022.jpeg'),
                                                                                                                Dates:"7-12-24"
                                                                                                                    
                                                                                                                
                                                                                                                
                                                                                                                
                                                                                                                
                                                                                                                },


                                                                                                                {
                                                                                                                    id:'29',
                                                                                                                    Title:"CHESS YEAH",
                                                                                                                    img: require('../data/photos/000023.jpeg'),
                                                                                                                    Dates:"7-12-24"
                                                                                                                        
                                                                                                                    
                                                                                                                    
                                                                                                                    
                                                                                                                    
                                                                                                                    },


                                                                                                                    {
                                                                                                                        id:'30',
                                                                                                                        Title:"Solo foto",
                                                                                                                        img: require('../data/photos/000027.jpeg'),
                                                                                                                        Dates:"20-11-24"
                                                                                                                            
                                                                                                                        
                                                                                                                        
                                                                                                                        
                                                                                                                        
                                                                                                                        },
        
                                                                                                                        {
                                                                                                                            id:'31',
                                                                                                                            Title:"Me gusto la vista",
                                                                                                                            img: require('../data/photos/000028.jpeg'),
                                                                                                                            Dates:"20-11-24"
                                                                                                                                
                                                                                                                            
                                                                                                                            
                                                                                                                            
                                                                                                                            
                                                                                                                            },


                                                                                                                            {
                                                                                                                                id:'32',
                                                                                                                                Title:"Esperar",
                                                                                                                                img: require('../data/photos/000030.jpeg'),
                                                                                                                                Dates:"20-11-24"
                                                                                                                                    
                                                                                                                                
                                                                                                                                
                                                                                                                                
                                                                                                                                
                                                                                                                                },


                                                                                                                                {
                                                                                                                                    id:'33',
                                                                                                                                    Title:"Personas",
                                                                                                                                    img: require('../data/photos/000031.jpeg'),
                                                                                                                                    Dates:"22-11-24"
                                                                                                                                        
                                                                                                                                    
                                                                                                                                    
                                                                                                                                    
                                                                                                                                    
                                                                                                                                    },


                                                                                                                                    {
                                                                                                                                        id:'34',
                                                                                                                                        Title:"Almuerzos",
                                                                                                                                        img: require('../data/photos/000032.jpeg'),
                                                                                                                                        Dates:"22-11-24"
                                                                                                                                            
                                                                                                                                        
                                                                                                                                        
                                                                                                                                        
                                                                                                                                        
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            id:'35',
                                                                                                                                            Title:"Ciudad donde hago surf",
                                                                                                                                            img: require('../data/photos/000029.jpeg'),
                                                                                                                                            Dates:"22-11-24"
                                                                                                                                                
                                                                                                                                            
                                                                                                                                            
                                                                                                                                            
                                                                                                                                            
                                                                                                                                            },
            

                  
                                                    
    


]

